import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { authUser, userLogout } from '@/redux/slices/auth.ts';
import { useAppSelector } from '@/lib/hooks';

const AuthInitializer: React.FC = () => {
    const dispatch = useDispatch();
    const {
        authenticatedUser: { accessToken, type },
    } = useAppSelector((state) => state.user);

    useEffect(() => {
        if (accessToken && type) {
            dispatch(authUser({ accessToken, type }));
        } else {
            dispatch(userLogout());
        }
    }, [accessToken, dispatch, type]);

    return null;
};

export default AuthInitializer;
